/**
 * Invoicing Tour Configuration
 *
 * Step-by-step tour guide for the Invoicing page.
 */

import { filterExistingSteps } from './tourUtils.js';

export const getInvoicingTourSteps = (t) =>
  filterExistingSteps([
    {
      selector: '[data-tour="invoicing-details"]',
      content: t('tour.invoicing.details', {
        ns: 'common',
        defaultValue: 'Enter customer information: email, phone, payment channel, and provider.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="invoicing-description"]',
      content: t('tour.invoicing.description', {
        ns: 'common',
        defaultValue: 'Add description or notes about the invoice.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="invoicing-items"]',
      content: t('tour.invoicing.items', {
        ns: 'common',
        defaultValue: 'Add invoice items with description, quantity, and unit price.',
      }),
      position: 'bottom',
    },
    {
      selector: '[data-tour="invoicing-summary"]',
      content: t('tour.invoicing.summary', {
        ns: 'common',
        defaultValue: 'Review totals, set tax, select currency, and send or download the invoice.',
      }),
      position: 'left',
    },
  ]);
